import React from 'react';
import { Star, Quote } from 'lucide-react';

const TrustElement = () => {
  // Platzhalter für spätere Google Reviews Integration
  const reviews = [
    {
      name: 'M. Schmidt',
      rating: 5,
      text: 'Schnelle Terminvergabe, sehr gründliche Dokumentation. Kann ich nur weiterempfehlen.'
    },
    {
      name: 'T. Weber',
      rating: 5,
      text: 'Freundlicher Kontakt, alles hat reibungslos geklappt. Gutachten war innerhalb von 2 Tagen fertig.'
    },
    {
      name: 'S. Müller',
      rating: 5,
      text: 'Unabhängige Begutachtung, faire Bewertung. Genau das, was ich gebraucht habe.'
    }
  ];

  return (
    <div className="glass-card" style={{
      background: 'linear-gradient(135deg, rgba(8, 145, 178, 0.05) 0%, rgba(6, 182, 212, 0.02) 100%)',
      border: '1px solid rgba(8, 145, 178, 0.15)',
      padding: '40px'
    }}>
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h3 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#1a202c',
          marginBottom: '12px'
        }}>
          Kundenstimmen
        </h3>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          marginBottom: '8px'
        }}>
          {[1, 2, 3, 4, 5].map((star) => (
            <Star key={star} size={20} fill="#F59E0B" color="#F59E0B" />
          ))}
        </div>
        <p style={{ fontSize: '14px', color: '#718096' }}>
          Basierend auf Kundenbewertungen
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {reviews.map((review, index) => (
          <div key={index} style={{
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: '12px',
            padding: '24px',
            position: 'relative'
          }}>
            <Quote size={24} style={{ color: '#0891B2', opacity: 0.3, marginBottom: '12px' }} />
            <p style={{
              fontSize: '15px',
              lineHeight: '1.6',
              color: '#4a5568',
              marginBottom: '16px'
            }}>
              "{review.text}"
            </p>
            <div>
              <div style={{
                display: 'flex',
                gap: '4px',
                marginBottom: '8px'
              }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <Star key={star} size={14} fill="#F59E0B" color="#F59E0B" />
                ))}
              </div>
              <p style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1a202c'
              }}>
                {review.name}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustElement;
